import { render, staticRenderFns } from "./bindUser.vue?vue&type=template&id=8a50abae&scoped=true"
import script from "./bindUser.vue?vue&type=script&lang=js"
export * from "./bindUser.vue?vue&type=script&lang=js"
import style0 from "./bindUser.vue?vue&type=style&index=0&id=8a50abae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a50abae",
  null
  
)

export default component.exports